<template>
  <div class="no-print">
    <div class="header">
      <LanguageSwitch></LanguageSwitch>
      <header-bar></header-bar>
    </div>
    <div
      class="d-block d-sm-block d-md-none designer"
      :style="{ background: 'white' }"
    >
      Der GT Designer ist für Anzeigen von 750px Breite optimiert.
    </div>
    <router-view></router-view>
  </div>
  <div id="print"></div>
</template>

<script>
import "./assets/styles/style.scss";
import "bootstrap/scss/bootstrap.scss";
import HeaderBar from "./components/Header.vue";
import LanguageSwitch from "@/views/components/LanguageSwitch.vue";
import { useStore } from "vuex";
import { onMounted } from "vue";

export default {
  name: "App",
  components: {
    HeaderBar,
    LanguageSwitch,
  },
  setup() {
    // onMounted(() => {
    //   window.addEventListener("beforeunload", (event) => {
    //     event.preventDefault();
    //     // Chrome requires returnValue to be set.
    //     return (event.returnValue =
    //       "Do you really want to leave? you have unsaved changes!");
    //   });
    // });
    const store = useStore();
    store.dispatch("importXMLs");
    return {};
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Lato");
@import "./assets/styles/style.scss";
#app {
  font-family: Lato, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.container-xl {
  background-color: #fff;
  height: calc(100vh - 132px);
}
.header {
  background-color: #fff;
  -webkit-box-shadow: 0px 15px 10px -15px #000000;
  box-shadow: 0px 15px 10px -15px #000000;
  /* border-bottom: 2px solid grey; */
  width: 100%;
}
body {
  background-color: #f5f5f5;
}
* {
  outline: none !important;
}
.vacp-color-inputs {
  /* display: none !important; */
}
.vacp-color-input {
  width: 50%;
}
.swiper-container-vertical > .swiper-pagination-bullets {
  left: 8% !important;
  top: 160px !important;
}
.swiper-pagination-bullet {
  height: 10px !important;
  width: 10px !important;
}
.swiper-pagination-bullet-active {
  background: #ffde00 !important;
}
.vacp-color-picker {
  max-width: inherit !important;
}
.vacp-color-space {
  max-height: 150px;
}
/* .swiper-container-vertical > .swiper-pagination-bullets {
  right: 40px !important;
  top: 40% !important;
} */
#print {
  display: none;
  margin-left: -50px;
}
@media (min-width: 768px) {
  .container {
    max-width: 100% !important;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px !important;
  }
}
@media (min-width: 1400px) {
  .container-xl {
    max-width: 1140px !important;
  }
  .container {
    max-width: 1140px !important;
  }
}
@media print {
  div {
    break-inside: avoid;
  }
  body {
    background-color: #fff;
  }
  .no-print {
    display: none;
  }
  #print {
    display: block;
  }
  .gt-btn {
    /* border: 1px dashed grey; */
    position: absolute;

    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    /* cursor: pointer; */
  }

  .inlay {
    font-family: Lato, Helvetica, Arial, sans-serif !important;
    position: relative;
    border: 2px solid black;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }

  p {
    margin: 0 !important;
    margin-bottom: 5px !important;
    z-index: 100;
    white-space: pre-line;
  }
  .gsa4 p {
    margin-bottom: 12px !important;
  }
  .gt-btn-container {
    height: inherit;
    width: inherit;
    position: absolute;
    top: 0;
    left: 0;
  }
  .gt-btn-img {
    background-repeat: no-repeat;
    position: absolute;
    z-index: 5;
  }
  .justify-content-center {
    justify-content: center;
  }
  .justify-content-start {
    justify-content: flex-start;
  }
  .justify-content-end {
    justify-content: flex-end;
  }
  .led {
    position: absolute;
    background-color: white;
  }
  .d-flex {
    display: flex;
  }
  .align-items-end {
    align-items: end;
  }
  .align-items-start {
    align-items: start;
  }
  .align-items-center {
    align-items: center;
  }

  .bar_g {
    position: absolute;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
  .bar_g_caption {
    position: absolute;
    font-size: 10px;
    line-height: 2.18mm;
    font-weight: bold;
  }
  .gt8 .gt8BlackTriangles {
    display: block;
    overflow: hidden;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOsAAAAPCAYAAAAF3zhBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIFdpbmRvd3MiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NkRERTE5NDU0QzJCMTFFN0JFODJENDQyODJGRkZGRUMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NkRERTE5NDY0QzJCMTFFN0JFODJENDQyODJGRkZGRUMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2RERFMTk0MzRDMkIxMUU3QkU4MkQ0NDI4MkZGRkZFQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2RERFMTk0NDRDMkIxMUU3QkU4MkQ0NDI4MkZGRkZFQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvKl2DoAAAC9SURBVHja7NVLCoRQDETR1P4XXd0NLYj4SaI+HdwLGWYSOEQR4e8oGtkOIsonqbtq/bFGByxYiYZg9QR0Lk5gJXoVVs9xLsUJrESvwOolzDVxAivRo1i9hnJLnMBK9AhWb4HcEyewEg3F6j2MR+IEVqIhWH0EMSNOYCW6FaszCLPiBFaiW7A6C7AiTmAluhSrK/iq4gRWokuwugqvI05gJTqF1R10XXECK1ELawvOGay/zyrOT1TC2vb2EWAAPgJLAVccOR8AAAAASUVORK5CYII=");
    background-repeat: no-repeat;
    background-position: bottom;
  }

  .gt10d .cutline {
    position: absolute;
    bottom: 6mm;
    width: 63mm;
    border-top: 2px dashed #999999;
  }

  .gt6 .cutline,
  .gt12 .cutline,
  .gt8 .cutline,
  .gt6l .cutline,
  .gt2 .cutline,
  .gsa4 .cutline {
    position: absolute;
    top: 6.5mm;
    width: 61mm;
    border-top: 2px dashed #999999;
  }

  .mt4 .cutline,
  .mt4 .cuttext,
  .gt6l .cutline,
  .gt6l .cuttext {
    display: none;
  }

  .cuttext {
    position: absolute;
    color: #999999;
  }
  .gt6 .cuttext,
  .gt2 .cuttext,
  .gt8 .cuttext,
  .gt12 .cuttext,
  .gt6l .cuttext,
  .gsa4 .cuttext {
    top: 0;
  }

  .gt10d .cuttext {
    bottom: 1mm;
  }
  .gt2t .cuttext {
    display: none;
  }
  .btn_text {
    word-break: break-word;
    color: #000;
  }
}
</style>
